import LoginSuccess from './LoginSuccess';

export default LoginSuccess;
